function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgPassword = function SvgPassword(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F2F4"
    },
    d: "M432,487H80c-44.112,0-80-35.888-80-80s35.888-80,80-80h352c44.112,0,80,35.888,80,80 S476.112,487,432,487z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6D737F"
    },
    cx: 206,
    cy: 407,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6D737F"
    },
    cx: 106,
    cy: 407,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D737F"
    },
    d: "M316,157H196c-8.284,0-15-6.716-15-15v-42c0-41.355,33.645-75,75-75s75,33.645,75,75v42 C331,150.284,324.284,157,316,157z M211,127h90v-27c0-24.813-20.187-45-45-45s-45,20.187-45,45V127z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E5F69"
    },
    d: "M256,25v30c24.813,0,45,20.187,45,45v27h-45v30h60c8.284,0,15-6.716,15-15v-42 C331,58.645,297.355,25,256,25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAC2B"
    },
    d: "M351,276H161c-8.284,0-15-6.716-15-15V142c0-8.284,6.716-15,15-15h190c8.284,0,15,6.716,15,15v119 C366,269.284,359.284,276,351,276z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF981E"
    },
    d: "M351,127h-95v149h95c8.284,0,15-6.716,15-15V142C366,133.716,359.284,127,351,127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF981E"
    },
    d: "M281,192c0-8.284-6.716-15-15-15h-20c-8.284,0-15,6.716-15,15c0,6.528,4.178,12.067,10,14.128V212 c0,8.284,6.716,15,15,15s15-6.716,15-15v-5.872C276.822,204.067,281,198.528,281,192z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFDAE0"
    },
    d: "M432,327H256v160h176c44.112,0,80-35.888,80-80S476.112,327,432,327z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5E5F69"
    },
    cx: 306,
    cy: 407,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5E5F69"
    },
    cx: 406,
    cy: 407,
    r: 25
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8512"
    },
    d: "M266,177h-10v50c8.284,0,15-6.716,15-15v-5.872c5.822-2.061,10-7.6,10-14.128 C281,183.716,274.284,177,266,177z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/password.c0f7da2f.svg";
export { ForwardRef as ReactComponent };